import {
  IFeatureInvitationCodeQuery,
  useFeatureInvitationCodeQuery,
} from 'generated/sanity-graphql';
import { useFeaturesContext } from 'state/features';

interface IUseFeatureInvitationCode {
  featureInvitationCodeLoading: boolean;
  featureInvitationCode: IFeatureInvitationCodeQuery['FeatureInvitationCode'];
}

export const useFeatureInvitationCode = (): IUseFeatureInvitationCode => {
  const { featureInvitationCodeId = '', featureIdsLoading } = useFeaturesContext();

  const { data, loading } = useFeatureInvitationCodeQuery({
    variables: { featureInvitationCodeId },
    skip: !featureInvitationCodeId,
  });

  const featureInvitationCode = data?.FeatureInvitationCode ?? null;
  const featureInvitationCodeLoading = featureIdsLoading || loading;

  return { featureInvitationCodeLoading, featureInvitationCode };
};
